/* eslint-disable react/prop-types */
import React from 'react';
import LoadingOverlay from "../../../../../components/core/ui/LoadingOverlay";
import RadioInput from "../../../../../components/core/input/RadioInput";
import TextInput from "../../../../../components/core/input/TextInput";
import SimpleButton from "../../../../../components/core/button/SimpleButton";
import { _AcceptRejectWrapper, _ButtonWrapper } from "../style";
var QuestionPreview = function QuestionPreview(_ref) {
  var QuestionComponent = _ref.questionComponent,
    questionInputProps = _ref.questionInputProps,
    questionStatus = _ref.questionStatus,
    acceptOrRejectInputProps = _ref.acceptOrRejectInputProps,
    showRejectionReasonInput = _ref.showRejectionReasonInput,
    rejectionReasonInputProps = _ref.rejectionReasonInputProps,
    rejectionReasonLoading = _ref.rejectionReasonLoading,
    rejectionReasonBtnProps = _ref.rejectionReasonBtnProps;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuestionComponent, questionInputProps), /*#__PURE__*/React.createElement(_AcceptRejectWrapper, {
    status: questionStatus
  }, rejectionReasonLoading && /*#__PURE__*/React.createElement(LoadingOverlay, null), /*#__PURE__*/React.createElement(RadioInput, acceptOrRejectInputProps), showRejectionReasonInput && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, rejectionReasonInputProps), /*#__PURE__*/React.createElement(_ButtonWrapper, null, /*#__PURE__*/React.createElement(SimpleButton, rejectionReasonBtnProps, "Save")))));
};
export default QuestionPreview;